new Vue({
    el:'.summer26',
    data(){
        return {
            loadFlag:false,
            isLottery:true,
            sendFlag:false,
            submitFlag:false,
            popup:false,
            recordPopup:false,
            addressPopup:false,
            prizePopup:false,
            sharePopup:false,
            rulePopup:false,
            loginPopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country',
                invite_code:'',
                points:0,
                is_win:false,
                invite_num:0
            },
            address:{
                state:'',
                city:'',
                street:'',
                postal:'',
                phone:''
            },
            popup1:false,
            select_flag1:0,
            countryArr:[],
            pointsHistory:[],
            recordNav:['Chance Record','Winning Record'], 
            recordIndex:0,
            // upload
            uploadImg:'',
            imagePosition: { x: 0, y: 0 }, // 图片的位置
            startDragPosition: { x: 0, y: 0 }, // 拖拽开始的位置
            isDragging: false, // 是否正在拖拽
            scale: 1, // 当前缩放比例
            minScale: 1, // 最小缩放比例
            maxScale: 5, // 最大缩放比例
            lastTouchDistance: 0, // 双指缩放时记录两指的初始距离
            isMouseInside: false, // 标志鼠标是否在容器内
            uploadFlag:false,
            isUpload:false,
            //图片宽高标识 0为横图 1为竖图
            imgFlag:1,
            prizeName:localStorage.getItem('OXVA_summer_prize') || '',
            className:'',
            prizeAll:{
                XLIM_GO_LITE:false,
                XLIM_PRO_3:false,
                OXVA_Summer_Merch:false,
                OXVA_NEXLIM_2_2_MINI_Gift_Box:false,
                Lucky_Try:false,
            },
            winnerArr:[]
        }
    },
    methods:{
        // 功能类-------------------------------------------------
        async submitAddress(){
            if(!this.address.state || !this.address.city || !this.address.street || !this.address.postal || !this.address.phone){
                return showMessage('Please fill in the information completely','error');
            } 

            //showMessage('Submitting, please wait...','success')
            //避免重复提交 
            if(this.submitFlag) return;
            this.submitFlag = true
            this.address.name = this.user.name
            this.address.email = this.user.email
            this.address.country = this.user.country

            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.address));
            let res = await axios.post('https://service.oxvatech.cn/summer/submitAddress',params, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                showMessage('Submission successful, preparing for shipment.','success')
            }else{
                let errorMessages = {
                    202: 'Ops, No winning information found.',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.popup = this.addressPopup = this.submitFlag = false
        },
        async lottery(){
            if(!this.checkLogin()) return;
            if(!this.isLottery) return;
            if(this.user.chance<1){
                showMessage('Oops! No Spins Left.','error')
                return;
            }

            // 开始抽奖
            this.isLottery = false
            let res = await axios.post('https://service.oxvatech.cn/summer/lottery',{},{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.status == 200){
                var status = res.data.status
                if(status==200){
                    //中奖
                    this.prizeName = res.data.data
                    localStorage.setItem('OXVA_summer_prize', this.prizeName) //存储中奖信息;
                    //&、空格和短横线转为下划线
                    var str = res.data.data.replace(/[ &-]/g, '_').replace(/_+/g, '_');
                    this.prizeAll[str] = true
                    this.Spin()
                    this.getInfo()
                    this.getData() //更新中奖者
                }else if(status==202){
                    //未中奖
                    this.prizeAll.Lucky_Try = true
                    this.user.chance -= 1
                    this.Spin()
                }else{
                    this.isLottery = true
                    let errorMessages = {
                        201: 'Oops! No Spins Left.',
                        500:' Server error, please contact customer service',
                    };
                    showMessage(errorMessages[status] || 'Unknown error', 'error');
                }
            }else{
                showMessage('Server Error','error')
            }
        },
        async getChance(type){
            if(type=='Upload'){
                if(this.user.is_upload==1) return;
            }else if(type=='Share'){
                if(this.user.is_share==1) return;
            }
            let params=new URLSearchParams();
            params.append('action',type);
            let res = await axios.post('https://service.oxvatech.cn/summer/getChance',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==200){
                this.getInfo() //更新积分记录
                showMessage("You've earned 1 extra spin!",'success')
            }
        },
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/summer/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            }
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交
            if(this.submitFlag) return;
            this.submitFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/summer/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_OXVA_Cheers_to_good_times_',res.data.data,90)
                this.user.token = res.data.data
                showMessage('Good luck! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.submitFlag = false
        },
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/summer/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.arr1.length>0){
                    this.isLogin = true
                    this.user = res.data.data.arr1[0]
                   
                    const winner = this.winnerArr.find(item => item.name == this.user.name) || {};
                    this.prizeName = winner.prize || '';
                    this.address.state = winner.state || '';

                    // if(this.user.name == ''){}

                    //总积分记录
                    this.pointsHistory = res.data.data.arr2
                    
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        async getData(){
            let res = await axios.get('https://service.oxvatech.cn/summer/getData')
            if(res.status == 200){
                this.winnerArr = res.data.data
                
                const winner = this.winnerArr.find(item => item.name == this.user.name) || {};
                this.prizeName = winner.prize || '';
                this.address.state = winner.state || '';
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
        // 控件类-------------------------------------------------
        startDrag(event) {
            event.preventDefault();
            
            const startX = event.type === "mousedown" ? event.clientX : event.touches[0].clientX;
            const startY = event.type === "mousedown" ? event.clientY : event.touches[0].clientY;
            
            this.startDragPosition = { x: startX, y: startY };
            this.isDragging = true;
            
            window.addEventListener("mousemove", this.drag);
            window.addEventListener("mouseup", this.stopDrag);
            window.addEventListener("touchmove", this.drag);
            window.addEventListener("touchend", this.stopDrag);
        },
        drag(event) {
            if (!this.isDragging) return;
            
            const currentX = event.type === "mousemove" ? event.clientX : event.touches[0].clientX;
            const currentY = event.type === "mousemove" ? event.clientY : event.touches[0].clientY;
            
            const deltaX = currentX - this.startDragPosition.x;
            const deltaY = currentY - this.startDragPosition.y;
            
            this.startDragPosition = { x: currentX, y: currentY };
            
            let newX = this.imagePosition.x + deltaX;
            let newY = this.imagePosition.y + deltaY;
            
            this.imagePosition = { x: newX, y: newY };
        },
        stopDrag() {
            this.isDragging = false;
            window.removeEventListener("mousemove", this.drag);
            window.removeEventListener("mouseup", this.stopDrag);
            window.removeEventListener("touchmove", this.drag);
            window.removeEventListener("touchend", this.stopDrag);
        },
        handleWheel(event) {
            if (!this.isMouseInside) return;
            if (this.uploadImg =='') return; // 仅在鼠标移入容器且上传了图片时触发
            event.preventDefault();
            event.stopPropagation();
            const scaleChange = event.deltaY > 0 ? -0.1 : 0.1;
            this.updateScale(this.scale + scaleChange, event.clientX, event.clientY);
        },
        handleTouchMove(event) {
            if (event.touches.length !== 2) return;
            
            const touch1 = event.touches[0];
            const touch2 = event.touches[1];
            
            const currentDistance = Math.hypot(
                touch2.clientX - touch1.clientX,
                touch2.clientY - touch1.clientY
            );
            
            if (this.lastTouchDistance) {
                const scaleChange = (currentDistance - this.lastTouchDistance) / 200;
                this.updateScale(this.scale + scaleChange, 
                    (touch1.clientX + touch2.clientX) / 2, 
                    (touch1.clientY + touch2.clientY) / 2);
            }
                
            this.lastTouchDistance = currentDistance;
        },
        updateScale(newScale, centerX, centerY) {
            newScale = Math.min(this.maxScale, Math.max(this.minScale, newScale));
            
            const image = this.$refs.image;
            const container = this.$refs.container;
            const imageRect = image.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            
            const offsetX = (centerX - containerRect.left) / this.scale;
            const offsetY = (centerY - containerRect.top) / this.scale;
            
            this.imagePosition.x -= offsetX * (newScale - this.scale);
            this.imagePosition.y -= offsetY * (newScale - this.scale);
            
            this.scale = newScale;
            
            const scaledWidth = imageRect.width * (newScale / this.scale);
            const scaledHeight = imageRect.height * (newScale / this.scale);
            
            this.imagePosition.x = Math.min(0, Math.max(this.imagePosition.x, containerRect.width - scaledWidth));
            this.imagePosition.y = Math.min(0, Math.max(this.imagePosition.y, containerRect.height - scaledHeight));
        },
        uploadFile(event){
            if(!this.uploadFlag){
                var file = event.target.files[0]
                if(file.size>6*1024*1024){
                    showMessage('The uploaded file cannot exceed 6M','error')
                    this.$refs.fileInput.value = "";
                    return;
                }else{
                    var that = this
                    this.uploadFlag=false
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        that.uploadImg = e.target.result; // 将图片的 base64 数据设为 img 的 src

                        const img = new Image();
                        img.src = e.target.result;

                        img.onload = function() {
                            if(img.width>img.height){
                                that.imgFlag = 0 //横图
                            }else{
                                that.imgFlag = 1
                            }
                        };

                        that.$refs.fileInput.value = "";
                        that.popup = that.sharePopup = true
                        that.isUpload = false
                        that.getChance('Upload')
                    };
                    reader.readAsDataURL(file); // 读取文件数据为 Data URL
                }
            }
        },
        async saveCanvas() {
            if (this.submitFlag) return;
            showMessage('Downloading, please wait. . .','success')
            this.submitFlag = true;
            
            const canvas = await html2canvas(this.$refs.container, {
                backgroundColor: null,
                useCORS: true,
                allowTaint: false
            })

            const link = document.createElement("a");
            link.download ="OXVA_Cheers_to_good_times.png";
            link.href = canvas.toDataURL("image/png");
            link.click();
            this.submitFlag = false;
        },
        openShare(){
            if(!this.checkLogin()) return;
            this.isUpload = true
            this.$refs.fileInput.click()
        },
        showPopup(type){
            if(!this.checkLogin()) return;
            this.popup = this[type] = true;
        },
        checkLogin(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return false;
            }
            return true;
            // showMessage('The event has ended, thank you for your participation','success');
            // return false
        },
        endTips(){
            showMessage('The event has ended, thank you for your participation.','success')
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        closeShare(){
            this.popup = this.sharePopup = false;
            this.imagePosition = { x: 0, y: 0 };
            this.scale = 1
        },
        // 工具类-------------------------------------------------
        formatISOToDateTime(isoString) {
            var date = new Date(isoString);
          
            // 转为北京时间（+8小时）
            date.setHours(date.getHours());
          
            var pad = (n) => n.toString().padStart(2, '0');
            var year = date.getFullYear();
            var month = pad(date.getMonth() + 1);
            var day = pad(date.getDate());
            var hours = pad(date.getHours());
            var minutes = pad(date.getMinutes());
            var seconds = pad(date.getSeconds());
          
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        copyCode(text){
            // 复制指定文案到剪贴板
            navigator.clipboard.writeText(text).then(() => {
                showMessage('Copied successfully','success')
            }).catch(err => {
                showMessage('Copied failed','error')
            });
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        Spin(){
            Object.keys(this.prizeAll).forEach((key)=>{
                if(this.prizeAll[key]){
                    //指向哪个奖品停止
                    this.className = key
                }
            })
            setTimeout(()=>{
                //显示奖品
                this.popup = this.prizePopup = true
            },8300)

            setTimeout(() => {
                //恢复转盘
                this.className = ''
                //可再次抽奖
                this.isLottery=true
            }, 8600);
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true

        if(this.getCookie('_OXVA_Cheers_to_good_times_')){
            this.isLogin = true
            this.user.token = this.getCookie('_OXVA_Cheers_to_good_times_')

            this.getInfo()
        }

        this.getCountry()
        this.getData()
    },
    mounted(){
        window.addEventListener("wheel", this.handleWheel,{ passive: false });

        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                }
            })
        }
        
        var wFlag = window.innerWidth>750

        $('.box2_item1').click(function(){
            document.querySelector(".box3").scrollIntoView({block: "start",behavior: "smooth"});
        })

        //box1
        ScrollTrigger.create({
            trigger:'.box1',
            start:wFlag?'top top+=5%':'top top+=6%',
            end:'+=30%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box1_bg img',{scale:0.5,opacity:0,stagger:{each: 0.1,from: "end"},ease:'none'})
                .from('.box1_icon1',{x:wFlag?'25rem':'8rem',y:wFlag?'8rem':'-5rem',scale:0.5})
                .from('.box1_icon2',{x:wFlag?'25rem':'-8rem',y:wFlag?'-10rem':'4rem',scale:0.5},'<')
                .from('.box1_icon3',{x:wFlag?'-21rem':'-4rem',y:wFlag?'14rem':'6rem',scale:0.5},'<')
        })
        ScrollTrigger.create({
            trigger:'.box1',
            start:wFlag?'top top+=5%':'top top+=6%',
            end:'+=50%',
            pin:true,
        })

        //box2
        gsap.registerPlugin(SplitText,ScrollTrigger)
        SplitText.create(".box2_title", {
            type: "chars", //words
            autoSplit: true,
            charsClass:"chars++",
            onSplit(self) {
                return gsap.from(self.chars, {
                    y: 100,
                    opacity: 0,
                    //duration: 0.7, 
                    ease: "power4",
                    stagger: 0.05,
                    scrollTrigger:{
                        trigger:'.box2',
                        start:'top bottom-=20%',
                        end:'+=0',
                        toggleActions:'play none none reverse',
                    }
                });
            }
        });

        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top top+=25%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                    .from('.box2_bg',{opacity:0})
                    .from('.box2Swiper .swiper-wrapper .swiper-slide:nth-child(1)',{x:'106%'})
                    .from('.box2Swiper .swiper-wrapper .swiper-slide:nth-child(3)',{x:'-106%'},'<')
            })
        }else{
            new Swiper('.box2Swiper', {
                //autoplay: true,
                slidesPerView: 1.5,
                centeredSlides: true,
            })
        }

        //box3
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=20%',
            end:'+=20%',
            //toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .to('.box3_bg',{filter:'brightness(0.3)'})
                .from('.box3_title p',{opacity:0})
                .from('.box3_hand',{opacity:0})
                .from('.box3_text',{scale:0})
                .from('.box3_btn',{opacity:0})
                .from('.box3 .box3_rule',{opacity:0},'<')
                .from('.box3_btn span',{opacity:0,stagger:{each: 0.2,from: "end"},ease:'none',repeat: -1,yoyo: true})
                // repeat: -1,yoyo: true
        })

        SplitText.create(".box3_title div", {
            type: "chars", //words
            autoSplit: true,
            charsClass:"box3_chars++",
            onSplit(self) {
                return gsap.timeline({
                    scrollTrigger: {
                        trigger: ".box3",
                        start: "top bottom-=20%",
                        end: "+=0",
                        toggleActions: "play none none reverse"
                    }
                })
                .from(self.chars, {
                    y: 100,
                    opacity: 0,
                    ease: "power4",
                    stagger: 0.05
                })
            }
        });

        //box4
        if(!wFlag){
            showUp('.box4_title')
        }

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top center-=20%',
            end:'+=0',
            animation:gsap.timeline()
                .from('.box4_text',{opacity:0,y:'6rem'})
        })

        if(wFlag){
            new Swiper('.box5Swiper1', {
                speed:12000,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                  //waitForTransition: false,
                },
                slidesPerView:6,
                loop:true
            })
    
            new Swiper('.box5Swiper2', {
                speed:12000,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                  reverseDirection: true
                  //waitForTransition: false,
                },
                slidesPerView:6,
                loop:true
            })
        }else{
            var box5Flag = true
            $('.box5_bottom div p').click(function(){
                if(box5Flag){
                    $(this).text('Show Less')
                    $('.box5_bottom img:nth-child(n+7)').show()
                }else{
                    $(this).text('View More')
                    $('.box5_bottom img:nth-child(n+7)').hide()
                }
                box5Flag = !box5Flag
            })
        }
    }
})